import { render, staticRenderFns } from "./Website_Link.vue?vue&type=template&id=81467336&scoped=true&"
import script from "./Website_Link.vue?vue&type=script&lang=js&"
export * from "./Website_Link.vue?vue&type=script&lang=js&"
import style0 from "./Website_Link.vue?vue&type=style&index=0&id=81467336&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81467336",
  null
  
)

export default component.exports